import o from "./novoui-vuejs71.js";
import "./novoui-vuejs72.js";
import t from "./novoui-vuejs73.js";
const p = /* @__PURE__ */ t(o, [["__scopeId", "data-v-7e07bda1"]]);
export {
  p as default
};
